import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupScreenRecordingWarningContentProps } from './msg-group-screen-recording-warning-content';
import { MsgGroupScreenRecordingWarningContent } from './msg-group-screen-recording-warning-content';

export interface MsgGroupScreenRecordingWarningProps
  extends MsgGroupScreenRecordingWarningContentProps {}

export const MsgGroupScreenRecordingWarning = memo(function MsgGroupScreenRecordingWarning({
  message,
}: MsgGroupScreenRecordingWarningProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupScreenRecordingWarningContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
